import QuizAnswer from './QuizAnswer';

let text;
let rect;

export default class MatchingAnswer extends QuizAnswer {
    constructor(data) {
        //Phaser gameobjects require a scene and type
        super(data);
    }


    createRect() {
        //text.setOrigin(0, 0.5);
        //Adjust the last method from parent createText
        text = this.text;
        text.setFontSize(22 * this.gameScale);
        this.space = 10 * this.gameScale;
        text.x += this.space;
        //create unique rectangle from parent
        let rectWidth = text.width + this.space * 2;
        let rectHeight = text.height + this.space / 2;
        rect = this.rect;
        rect = this.holder.add.rectangle(text.x + text.width / 2, text.y, rectWidth, rectHeight, 0x72B49C).setAlpha(0.9).setOrigin(0.5);

        this.rect = rect;
        this.createIcon();

    }

    activateButton() {
        this.rect = rect;
        //make adjustments to parent settings before activating
        this.icon.x = this.text.x - this.space * 2 - this.icon.width / 2;
        this.btn.setSize(this.rect.width, this.rect.height);
        super.activateButton();
        //make it interactive with a hit area
        //make it interactive with a hit area
        this.btn.removeInteractive();
        this.btn.setInteractive({
            useHandCursor: true,
            hitArea: new Phaser.Geom.Rectangle(this.rect.x, this.rect.y, this.btn.width, this.btn.height),
            hitAreaCallback: Phaser.Geom.Rectangle.Contains

        });
        // this.holder.input.enableDebug(this.btn, 0xffcc00);
    }

}